module.exports = __webpack_public_path__ + "static/media/grey-sakura.815720b8.svg";